import React from "react";

export function Loader({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center py-24" data-testid="loader">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 rounded-full border-2 border-arq-green/20 border-t-arq-green animate-spin" />
        <span className="text-xs uppercase tracking-widest text-muted-foreground">{label}</span>
      </div>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 border border-dashed border-border rounded-md bg-arq-card/40" data-testid="empty-state">
      {Icon && <Icon className="h-8 w-8 text-muted-foreground mb-3" strokeWidth={1.4} />}
      <p className="font-display text-lg text-arq-ink">{title}</p>
      {subtitle && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{subtitle}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function SectionHeading({ overline, title, children }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        {overline && <p className="text-[11px] uppercase tracking-[0.2em] text-arq-accent font-semibold mb-1">{overline}</p>}
        <h1 className="font-display text-3xl sm:text-4xl text-arq-ink">{title}</h1>
      </div>
      {children}
    </div>
  );
}
